import { RootReducer } from 'store/reducers';

export const assessment = (state: RootReducer) => state.assessment;

export const getJobToken = (state: RootReducer) => state.assessment.jobToken;

export const isBrandedDocument = (state: RootReducer) =>
  state.assessment.isBrandedDocument;

export const getSupportedReviews = (state: RootReducer) =>
  state.assessment.supportedReviews;

// TO DO: refactor, because no warning properties in assessmentSsiVersions

export const messages = (state: RootReducer) => state.messages;
